import images from '../config/local/images';
import InlineSVG from 'react-inlinesvg/esm';
import React from 'react';

/** @extends {React.Component<{className?: string}, {}>} */
export default class Loading extends React.Component {
	render() {
		return (
			<div className={`spinner ${this.props.className ?? ''}`}>
				<InlineSVG className="icon" src={images.icons.spinner} />
			</div>
		);
	}
}
